/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/suppression_rules/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSuppressionRulesId } from "./constants";
import type {
  GetEngagementAppGroupIdSuppressionRulesIdProps,
  GetEngagementAppGroupIdSuppressionRulesIdResult,
} from "./types";
import { isGetEngagementAppGroupIdSuppressionRulesIdResult } from "./validators";

/**
 * GET handler for the "/engagement/:app_group_id/suppression_rules/:id" endpoint
 */
export const getEngagementAppGroupIdSuppressionRulesId = reactQueryFetcherAdapter(
  engagementAppGroupIdSuppressionRulesId,
  (
    signal: AbortSignal,
    { appGroupId, id }: GetEngagementAppGroupIdSuppressionRulesIdProps
  ): Promise<GetEngagementAppGroupIdSuppressionRulesIdResult> => {
    return fetch(`/engagement/${appGroupId}/suppression_rules/${id}`, "GET", {}, { signal });
  },
  isGetEngagementAppGroupIdSuppressionRulesIdResult
);
